/* global jQuery, Skyhook, ajaxurl, Infinity, grecaptcha, PHPUNIT_ALP_TESTING */

'use strict'

/**
 * @module Обёртка для формы заказа
 * @author okto web@axisful.info
 */
const OrderWrapper = function ($) {
  const EVENT_TYPE_RESTORE_DATA = 'alpine:restore-form-data'
  const EVENT_TYPE_UPDATE_INFO = 'alpine:update-info'
  const EVENT_ENABLE_LOCK = 'alpine:enable-lock'
  const EVENT_RELEASE_LOCK = 'alpine:release-lock'
  const EVENT_FORM_INITED = 'alpine:form-inited'
  const CLASS_CONTROLS_LOCKED = 'controls-locked'
  const CLASS_FORM_LOADING = 'form-loading'
  const CLASS_FORM_FADE_IN = 'fadeIn'

  const ERROR_PLACEHOLDER = '[Не найдено]'
  const ERROR_HANDLERS = {
    people: handleClientsCountError
  }

  const TXT_NAME_SINGULAR = 'Меня зовут <em>(имя и фамилия)</em>'
  const TXT_NAME_PLURAL = 'Нас зовут <em>(имя и фамилия)</em>'
  const TPL_HAS_DISCOUNT = '<span class="alp-info-has-discount">Действует скидка {val}%</span>'

  const $form = $('#ac-base-form')
  const $concList = $(':input[name=conc_programm_id]')
  const $priceBox = $('#conc-price-ct')
  const $priceClearBox = $('#conc-clear-price-ct')
  const $clientsCountBox = $('#people')
  const $prepayBox = $(':input[name=prepay]')
  const $sessionsList = $(':input[name=session_id]')
  const $usernameInput = $(':input[name=username]')
  const $userLabel = $('#client-name-label')
  const $sessionDiscountInfoBox = $('#conc-session-info')
  const $submitBtn = $('#save')
  const $extraBox = $('#username-box')
  const $msgNoSeats = $('.warning-msg-ct--no-seats-available')

  let isFormControlsLocked
  let sessionConcsStorage = {}

  /**
   * public static void main
   */
  function init() {
    enableSysEvents()

    $form.trigger(EVENT_ENABLE_LOCK)

    prepareVars()
    buildConcsList()
    renderControls()
    prepareControls()

    $form.trigger(EVENT_RELEASE_LOCK)
    $form.trigger(EVENT_FORM_INITED)
  }

  function enableSysEvents() {
    $form.on(EVENT_ENABLE_LOCK, function () {
      setLockStatus(true)
    })

    $form.on(EVENT_RELEASE_LOCK, Skyhook.debounce(function () {
      setLockStatus(false)
    }, 500))
  }

  function prepareVars() {
    try {
      sessionConcsStorage = JSON.parse($('#alp-concs-list').text())
      if ($.isEmptyObject(sessionConcsStorage).length) {
        throw new Error('Empty sessionConcsStorage JSON')
      }
    } catch (error) {
      Skyhook.error('Cannot parse Sessions/Concs JSON. Call the Ghostbusters!', error)
    }
  }

  /**
   * Отразить в UI состояние загрузки
   *
   * @param {Boolean} isLocked
   */
  function setLockStatus(isLocked) {
    document.body.style.cursor = isLocked ? 'wait' : 'default'
    isFormControlsLocked = isLocked

    const $wrapper = $form.parent()
    const firstLoad = $wrapper.hasClass(CLASS_FORM_LOADING)

    if (isLocked) {
      if (!firstLoad) {
        $form.removeClass(CLASS_FORM_FADE_IN)
        $wrapper.addClass(CLASS_CONTROLS_LOCKED)
      }
    } else {
      if (firstLoad) {
        $form.addClass(CLASS_FORM_FADE_IN)
      }

      $wrapper
        .removeClass(CLASS_CONTROLS_LOCKED)
        .removeClass(CLASS_FORM_LOADING)
    }
  }

  function prepareControls() {
    bindFormEvents()
    bindFormErrorsHandling()
    bindFormValidation()

    $form.trigger(EVENT_TYPE_RESTORE_DATA)
  }

  function bindFormEvents() {
    $sessionsList.change(buildConcsList)
    $concList.change(updateInfoBoxes)
    $prepayBox.change(updatePriceBox)
    $clientsCountBox.change(handleClientsCountChange)

    $form.on(EVENT_TYPE_UPDATE_INFO, updateInfoBoxes)
    $form.one(EVENT_TYPE_RESTORE_DATA, restoreFormData)

    // Для случая возврата назад или после неудачной капчи
    trackNameInputs()
    updateInfoBoxes()
  }

  /**
   * JS-реализация контролов формы
   * Метод отрисовывает контролы и отпускает блокировку формы
   */
  function renderControls() {
    unMasqEmails()
    enableJsLists()
    enableNumberControl()
  }

  function unMasqEmails() {
    $('[data-hook="masq-email"]').each(function () {
      const $el = $(this)
      const email = [$el.text().trim(), '@', $el.data('domain')].join('')

      $el.replaceWith(
        $('<a>').text(email).attr('href', 'mailto:' + email)
      )
    })
  }

  function enableJsLists() {
    const isTest = typeof PHPUNIT_ALP_TESTING !== 'undefined'

    if ($.fn.select2 && !isTest) {
      $concList.select2({
        placeholder: 'Выберите Программу',
        minimumResultsForSearch: Infinity,
        noResults: 'Нет результатов',
        searching: 'Поиск…',
        width: 'resolve'
      })

      $sessionsList.select2({
        placeholder: 'Выберите Смену',
        //allowClear: true,
        width: 'resolve',
        minimumResultsForSearch: Infinity,
        noResults: 'Нет результатов',
        searching: 'Поиск…'
      })
    }
  }

  /**
   * Загрузить список ОП для Смены
   */
  function buildConcsList() {
    const params = Skyhook.getParams() || []
    const sessionId = $sessionsList.val()

    /** @var {String} concId */
    const concId = params['conc_id']

    /** @var {String} programmId */
    const programmId = $concList.find(':selected').data('programm_id')
    const selectedOpts = {
      programmId: +programmId || -1,
      //!NB имеет больший приоритет
      concId: +concId || -1
    }

    renderConcs(sessionId, selectedOpts)
  }

  /**
   * Функции, которые вызываеются после загрузки ОП.
   */
  function updateInfoBoxes() {
    trackSessionDiscount()
    updatePriceBox()
    updateClearPriceBox()
    updateSubmitButtonText()
  }

  /**
   * Отобразить список ОП для Смены
   *
   * @param {String} sessionId
   * @param {Object} selectedOpts
   * @param {Number} [selectedOpts.concId]
   * @param {Number} [selectedOpts.programmId]
   */
  function renderConcs(sessionId, selectedOpts) {
    const rows = sessionConcsStorage[sessionId] || []
    const options = rows.map(function (row) {
      const dataAttrs = Skyhook.buildDataAttributes(row, ['people_booked_qty'])
      let selectedAttr = ''

      if (row.id && (
        +row.id === selectedOpts.concId ||
        +row.programm_id === selectedOpts.programmId
      )) {
        selectedAttr = 'selected'
      }

      return [
        '<option value="',
        row.id,
        '" class="opt-status-',
        row.status,
        '" ',
        dataAttrs,
        ' ',
        selectedAttr,
        '>',
        row.name,
        '</option>'
      ].join('')
    })

    $concList
      .empty()
      .removeAttr('disabled')
      .append(options.join(''))
      .trigger('change')
  }

  /**
   * Отображение актуальной цены в зависимости от кол-ва мест и программы.
   *
   * @returns {void}
   */
  function updatePriceBox() {
    const clientsCount = getClientsCount()
    const prepay = getPrepay()
    const price = getPrice()

    const total = price * clientsCount * prepay
    if (!total) {
      throw new Error('Cannot calculate total sum')
    }

    // Строим строку калькуляции
    let meta
    if ((clientsCount !== 1) || (prepay !== 1)) {
      meta = '%price%'

      if (clientsCount > 1) {
        meta = '%meta% &times; %people%'.replace('%meta%', meta)
        if (prepay < 1) {
          meta = '(%meta%)'.replace('%meta%', meta)
        }
      }

      if (prepay < 1) {
        meta = '%meta% &times; %prepay%%'.replace('%meta%', meta)
      }

      meta = '%meta% = <span class="price price--total">%total%</span>'.replace('%meta%', meta)
    } else {
      meta = '<span class="price">%price%</span>'
    }

    const txt = meta
      .replace('%people%', clientsCount)
      .replace('%prepay%', prepay * 100)
      .replace('%price%', Skyhook.formatCurrency(price))
      .replace('%total%', Skyhook.formatCurrency(total))

    $priceBox
      .hide()
      .html(txt)
      .attr('data-price', price)
      .attr('data-total', total)
      .attr('data-prepay', prepay * 100)
      .fadeIn()
  }

  /**
   * Обновить контейнер со стоимостью курса.
   */
  function updateClearPriceBox() {
    const clearPrice = getPrice(true)
    const clearPriceFormatted = Skyhook.formatCurrency(clearPrice)

    $priceClearBox
      .hide()
      .attr('data-conc-price', clearPrice)
      .html(clearPriceFormatted)
      .fadeIn()
  }

  function updateSubmitButtonText() {
    const $conc = $concList.find(':selected')
    const hasBookingEnabled = Boolean(+$conc.data('bed_booking_enabled'))

    if (hasBookingEnabled) {
      if ($submitBtn.val() === $submitBtn.data('value-booking-disabled')) {
        $submitBtn.val($submitBtn.data('value-booking-enabled'))
      }
    } else {
      if ($submitBtn.val() !== $submitBtn.data('value-booking-disabled')) {
        $submitBtn.val($submitBtn.data('value-booking-disabled'))
      }
    }
  }

  /**
   * Получить процент от общей суммы, которую собирается
   * оплатить пользователь.
   *
   * @return {Number}
   */
  function getPrepay() {
    const dis = $prepayBox.filter(':checked').data('prepay-value')

    return dis ? (parseInt(dis) / 100) : 1
  }

  /**
   * Получить количество участников
   *
   * @return {Number}
   */
  function getClientsCount() {
    return parseInt($clientsCountBox.val()) || 1
  }

  /**
   * Рассчитать цену программы с учётом скидок Смены
   *
   * @param {Boolean|null} clear [false] Возвратить цену для курса без расчёта предоплаты etc.
   * @return {Number}
   */
  function getPrice(clear) {
    const $conc = $concList.find(':selected')
    const $session = $sessionsList.find(':selected')
    const errors = []

    let price

    if (!$conc.length) {
      $concList.select2({ placeholder: ERROR_PLACEHOLDER })

      errors.push('ОП не найдена в списке доступных')
    }
    if (!$session.length) {
      $session.select2({ placeholder: ERROR_PLACEHOLDER })

      errors.push('Смена не найдена в списке доступных')
    }

    if (errors.length) {
      const msg = errors.join('\n')

      Skyhook.log('Ошибка:', msg)
      throw new Error(msg)
    }

    price = parseInt($conc.data('price_calculated'))

    if (isNaN(price) || !price) {
      throw new Error('Invalid price')
    }

    if (clear) {
      return price
    }

    return price
  }

  /**
   * Существует ли скидка для данной ОП.
   *
   * @param {jQuery} $session
   * @param {jQuery} $conc
   * @returns {Boolean}
   */
  function hasDiscount($session, $conc) {
    const discount = parseInt($conc.data('discount')) === 1
    const discountValue = parseInt($session.data('discount_value'))

    return (discountValue > 0) && discount
  }

  /**
   * Актуальное количество полей с вводом участников
   */
  function trackNameInputs() {
    const clientsCount = getClientsCount()
    const availableQty = $concList.find(':selected').data('available_qty')
    const count = Math.min(availableQty, clientsCount) || 0

    const $extraOpts = $('input.extra_people-input')
    const present = $extraOpts.length
    const hasAnimation = !window.PHPUNIT_ALP_TESTING
    let delta = count - present - 1

    if (!delta) {
      return
    }

    $form.on('submit', preventDefault)
    $form.parsley().destroy()

    if (delta > 0) {
      // Добавить поля
      while (delta--) {
        const $newBox = $usernameInput.clone()
          .attr('class', 'extra_people-input')
          .attr('name', 'extra_people[]')
          .removeAttr('id')
          .val('')

        if (hasAnimation) {
          $newBox
            .hide()
            .appendTo($extraBox)
            .slideDown('fast')
        } else {
          // Для тестов без анимации
          $newBox.appendTo($extraBox)
        }
      }
    } else {
      // Удалить поля
      /* eslint-disable no-lonely-if */
      if (hasAnimation) {
        $extraOpts.slice(delta).slideUp('fast', function () {
          $(this).remove()
        })
      } else {
        // Для тестов без анимации
        $extraOpts.slice(delta).remove()
      }
    }
    /* eslint-enable no-lonely-if */

    // Перезагрузить валидацию для новых полей
    setTimeout(function () {
      $form.parsley()
      $form.off('submit', preventDefault)
    }, 0)

    $userLabel.html(count > 1 ? TXT_NAME_PLURAL : TXT_NAME_SINGULAR)
  }

  /**
   * Обновить статус скидки
   * NB Не используется
   */
  function trackSessionDiscount() {
    const $session = $sessionsList.find(':selected')
    const $conc = $concList.find(':selected')
    const discountValue = parseInt($session.data('discount_value'))

    if (hasDiscount($session, $conc)) {
      $sessionDiscountInfoBox.hide()
        .html(TPL_HAS_DISCOUNT.replace('{val}', discountValue.toString()))
        .fadeIn()
    } else {
      $sessionDiscountInfoBox.fadeOut(function () {
        $(this).hide()
      })
    }
  }

  function bindFormErrorsHandling() {
    let tid
    let $el

    // Прокрутить к самому первому элементу
    window.Parsley.on('field:error', function () {
      if (tid) {
        return
      }
      $el = this.$element

      // Если фокус на элементе, не прокручивать к нему
      if ($el.is(':focus')) {
        return
      }

      if (ERROR_HANDLERS[$el.attr('id')]) {
        ERROR_HANDLERS[$el.attr('id')]($el)
      }

      tid = setTimeout(function () {
        Skyhook.focusOn($el, Skyhook.constructor.OFFSET_TOP)
        $el.focus()
        tid = null
      }, 200)
    })
  }

  function bindFormValidation() {
    $submitBtn.on('click', function (event) {
      event.preventDefault()

      const parsleyForm = $form.parsley()
      try {
        parsleyForm
          ._refreshFields()

        parsleyForm
          .whenValidate()
          .then(function () {
            setLockStatus(true)
            displayFormSubmit()

            // Для локальной отладки отключить капчу
            if (!Skyhook.debugCaptchaEnabled && Skyhook.captchaDisabledForDebug) {
              submitForm()
            } else {
              grecaptcha
                .execute()
                .then(submitForm)
            }
          })
      } catch (error) {
        console.error(error)
        $form.trigger(EVENT_RELEASE_LOCK)
      }
    })
  }

  function displayFormSubmit() {
    $form
      .find('input, textarea, .alp-prepay-list-control, .alp-extra-option-bed-ct')
      .addClass('disabled')

    $submitBtn
      .attr('disabled', true)
      .val('Отправляю…')
  }

  function submitForm() {
    trackSessionData()
    $form.submit()
  }

  function trackSessionData() {
    Skyhook.SessionStorage.saveOrderFormData($form.serializeArray())

    const bookingData = Skyhook.SessionStorage.getOrderBookingData()
    if (bookingData) {
      const bookingClientsCount = bookingData.filter(function (entry) {
        return entry.name === 'clients_count'
      })

      // Если на форме с планом кол-во участников отличается от текущего, сбросить данные формы
      if (bookingClientsCount && +bookingClientsCount.value !== getClientsCount()) {
        Skyhook.SessionStorage.clearOrderBookingData()
      }
    }
  }

  /**
   * Подготовить контрол с количеством участников
   */
  function enableNumberControl() {
    const $numControl = $('#quantity-control')
    const $input = $numControl.find('input[type="number"]')
    const $btnUp = $numControl.find('.quantity-up')
    const $btnDown = $numControl.find('.quantity-down')
    const min = parseInt($input.attr('min'))
    const max = parseInt($input.attr('max'))

    if (isNaN(min) || isNaN(max)) {
      Skyhook.log('Number control: min and max values not valid: ' + [min, max])

      return
    }

    const clearButtonsState = function () {
      $btnUp.removeClass('disabled')
      $btnDown.removeClass('disabled')
    }

    $btnUp.click(function (event) {
      if (isFormControlsLocked) {
        event.preventDefault()

        return
      }

      const oldValue = parseInt($input.val())
      const newVal = oldValue + 1

      if (newVal === max) {
        $btnUp.addClass('disabled')
      } else if (newVal < max) {
        clearButtonsState()
      } else {
        return
      }

      $numControl.find('input').val(newVal).attr('value', newVal)
      $numControl.find('input').trigger('change')
    })

    $btnDown.click(function (event) {
      if (isFormControlsLocked) {
        event.preventDefault()

        return
      }

      const oldValue = parseInt($input.val())
      const newVal = oldValue - 1

      if (newVal === min) {
        $btnDown.addClass('disabled')
      } else if (newVal > min) {
        clearButtonsState()
      } else {
        return
      }

      $numControl.find('input').val(newVal).attr('value', newVal)
      $numControl.find('input').trigger('change')
    })
  }

  function restoreFormData() {
    const data = Skyhook.SessionStorage.getOrderFormData()
    const restoredData = Skyhook.SessionStorage.normalizeOrderFormData(data)
    if (!restoredData) {
      return
    }

    // Программа
    const restoredConcId = +restoredData['conc_programm_id']
    if (+$concList.find(':selected').val() !== restoredConcId) {
      const availConcIds = $.map($concList.find('option'), function (item) {
        return +item.value
      })

      if (~$.inArray(restoredConcId, availConcIds)) {
        $concList.find('option[value=%d]'.replace('%d', restoredConcId)).attr('selected', true)
        $concList.val(restoredConcId)
        $concList.trigger('change')
      }
    }

    // Смена
    if (+$sessionsList.find(':selected').val() !== +restoredData['session_id']) {
      $form.one(EVENT_TYPE_RESTORE_DATA, restoreFormData)
      $sessionsList.val(restoredData['session_id']).trigger('change')
    }

    /* SIMPLE FIELDS */
    const simpleTextInputs = ['username', 'email', 'phone']
    for (const index in simpleTextInputs) if (simpleTextInputs.hasOwnProperty(index)) {
      const name = simpleTextInputs[index]
      const $input = $('input[name=%s]'.replace('%s', name))

      if ($input.val() !== restoredData[name]) {
        $input.val(restoredData[name])
      }
    }

    // Комментарий
    const $commentTextarea = $('textarea[name=comment]')
    if ($commentTextarea.val() !== $commentTextarea['comment']) {
      $commentTextarea.val(restoredData['comment'])
    }

    // Юзернеймы
    $clientsCountBox.val(restoredData['people'])
    trackNameInputs()
    restoreUsernames(restoredData['extra_people[]'])

    // Полная сумма или предоплата
    $prepayBox
      .filter('#prepay-%s'.replace('%s', restoredData['prepay']))
      .prop('checked', true)

    $form.trigger(EVENT_TYPE_UPDATE_INFO)
  }

  function restoreUsernames(usernames) {
    usernames = usernames || []
    const extraPeopleSelector = '[name="extra_people[]"]:eq(%d)'

    for (let i = 0; i < usernames.length; i++) {
      $(extraPeopleSelector.replace('%d', i)).val(usernames[i])
    }
  }

  function handleClientsCountChange(event) {
    hideNoSeatsMessage()

    // Динамическое кол-во участников
    const availableQty = $concList.find(':selected').data('available_qty')
    const countMax = Math.min(parseInt(availableQty), parseInt($clientsCountBox.attr('max')) || 10)
    const countMin = parseInt($clientsCountBox.attr('min')) || 1

    if (isFormControlsLocked) {
      event && event.preventDefault()

      return
    }

    if (this.value > countMax) {
      this.value = countMax
      showNoSeatsMessage(countMax)
    } else if (this.value < countMin) {
      this.value = countMin
    }

    updatePriceBox()
    trackNameInputs()
  }

  function showNoSeatsMessage(count) {
    $msgNoSeats.removeClass('hidden')

    const message = [
      count,
      Skyhook.getBedsAmountSuffix(count)
    ].join(' ')

    const $msg = $msgNoSeats.find('.warning-msg')
    $msg.html(
      $msg.html().replace('{$count}', message)
    )
  }

  function hideNoSeatsMessage() {
    $msgNoSeats.addClass('hidden')
  }

  function handleClientsCountError() {
    $clientsCountBox.trigger('change')
  }

  function preventDefault(event) {
    event.preventDefault()

    return false
  }

  // Public API
  return {
    init: init
  }
}

jQuery(function () {
  new OrderWrapper((jQuery)).init()
})
